import React, { useState } from 'react';
import './ColorModeSwitch.css';

const ColorModeSwitch = ({mode, onClick, sx}) => {
  // const [mode, setMode] = useState('Solid');

  return (
    <div className="color-mode-switch" style={sx}>
      <button
        className={`mode-button ${mode === 'Solid' ? 'active' : ''}`}
        onClick={onClick}
      >
        Solid
      </button>
      <button
        className={`mode-button ${mode === 'Multi' ? 'active' : ''}`}
        onClick={onClick}
      >
        Multi
      </button>
    </div>
  );
};

export default ColorModeSwitch;